import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Aos from 'aos';
import './aos.css';

// Array of card data
const cardData = [
  {
    title: "Mission Statement",
    text: `ACE International Academy offers Cambridge International Examinations – CIEs/University of Cambridge Local Examinations Syndicate (UCLES) curricula that enables its multi-ethnic students to achieve their optimum intellectual, social, emotional and physical potential; encouraging in them respect for others, benevolence and good manners. ACE; dedicated to Academic Creative Excellence; demands responsibility and promotes the power of collaboration with stress on critical thinking to develop valuable citizens making their country proud.`,
    image: `${process.env.PUBLIC_URL}/imageshome/mission1.jpg`,
    bgColor: "#6495ED", // dark gray
    textColor: "#000000", // white text
  },
  {
    title: "Objectives",
    text: `Providing students with opportunities to make learning a pleasure and enabling them to enjoy this learning both intellectually and emotionally is one of our aims. The modern educational concept of promoting learning-to-learn and how to apply has been incorporated into our instructional techniques and methodology.`,
    image: `${process.env.PUBLIC_URL}/imageshome/objectives2.jpg`,
    bgColor: "#fadbd8", // darker gray
    textColor: "#000000", // light gray text
  },
  {
    title: "Special Needs",
    text: `We are not equipped to facilitate for special needs. Parents must fully inform Academy if any such condition/requirement at the time of admission. In case of not reporting, the Academy holds full authority to withdraw admission.`,
    image: `${process.env.PUBLIC_URL}/imageshome/need.png`,
    bgColor: "#40E0D0", // almost black
    textColor: "#000000", // light text
  },
];

// Helper to split array into chunks of 3
const chunkArray = (arr, chunkSize) => {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
};

function GroupExample() {
  const rows = chunkArray(cardData, 3); // Split into rows of 3

useEffect(() => {
    Aos.init({});
  }, [])


  return (
    <Container fluid className="mt-4 px-4">
   
      {rows.map((row, rowIndex) => (
        <Row key={rowIndex} className="mb-4">
              
          {row.map((card, colIndex) => (
            <Col md={4} key={colIndex}>
              <div data-aos="flip-left" data-aos-duration="2500">
              <Card className="h-100" style={{ backgroundColor: card.bgColor, color: card.textColor }}>
                <Card.Img variant="top" src={card.image} />
                <Card.Body>
                  <Card.Title>{card.title}</Card.Title>                  
                </Card.Body>
                <Card.Footer>
                  <Card.Text>{card.text}</Card.Text>
                </Card.Footer>
              </Card>
               </div>
            </Col>
          ))}
         
        </Row>
      ))}
   
    </Container>
  );
}

export default GroupExample;




// import '../../StyleSheets/StyleSheetPages.css';

// function MissionStatement() {
//   return (
//     <div className="stylesheetpage-container">
//       <div className="stylesheetpage-box">
//         <h2 className="stylesheetpage-title">ACE Mission Statement</h2>
//         <p className="stylesheetpage-text">
//           ACE International Academy offers Cambridge International Examinations – CIEs/University of Cambridge Local Examinations Syndicate (UCLES) curricula that enables its multi-ethnic students to achieve their optimum intellectual, social, emotional and physical potential; encouraging in them respect for others, benevolence and good manners. ACE; dedicated to Academic Creative Excellence; demands responsibility and promotes the power of collaboration with stress on critical thinking to develop valuable citizens making their country proud.
//         </p>

//         <h3 className="stylesheetpage-title">Objectives</h3>
//         <p className="stylesheetpage-text">
//           The chief objective of the Academy is to provide quality education of an international standard to students of various nationalities. The harmonious co-existence of these students enables the Academy to promote effective international awareness by providing them with opportunities to mutually share universally valid ideas, cultural norms, traditions, beliefs, customs that each individual may bring to develop a sense of unity among them.
//         </p>
//         <p className="stylesheetpage-text">
//           Providing students with opportunities to make learning a pleasure and enabling them to enjoy this learning both intellectually and emotionally is one of our aims. The modern educational concept of promoting learning-to-learn and how to apply has been incorporated into our instructional techniques and methodology.
//         </p>
//         <p className="stylesheetpage-text">
//           All educational curricula in the Academy are designed so as to develop essential knowledge, skills, positive attitude and capabilities in each individual student. We strongly believe that education is a powerful instrument which develops confident individuals with social and ethical values capable of contributing to a better world.
//         </p>

//         <h3 className="stylesheetpage-title">Special Needs</h3>
//         <p className="stylesheetpage-text">
//           We are not equipped to facilitate for special needs. Parents must fully inform Academy if any such condition/requirement at the time of admission. In case of not reporting, the Academy holds full authority to withdraw admission.
//         </p>
//       </div>
//     </div>
//   );
// }

//export default MissionStatement;
